import tw from 'twin.macro'
import React from 'react'
import { size } from 'lodash'

import { useAuth } from 'modules/Auth/hooks/useAuth'
import { useListenCoachVideosQuery } from 'modules/VideoLibrary/videoLibraryApi'
import { useListenUserProfileQuery } from 'modules/Users/userApi'

import { Skeleton } from 'common/components/Skeleton/Skeleton'
import { LayoutCard } from './LayoutCard'

export const VideoCard = React.memo(({ item, previewImg, handleDelete }) => {
  const { userId } = useAuth()
  const { data: profile } = useListenUserProfileQuery({ userId })
  const coachOrgId = profile?.coachOrgId || ''

  const { data: videoData } = useListenCoachVideosQuery({ coachOrgId })
  const videos = videoData?.isLoading || videoData === null || videoData === undefined ? {} : videoData

  if (videoData?.isLoading) {
    return <Skeleton css={tw`w-60 h-44 rounded-xl`} />
  }

  if (!videos || size(videos) === 0) {
    return null
  }

  const video = videos[item.id]
  if (video) {
    return (
      <LayoutCard
        id={item.id}
        type={item.type}
        name={video.title}
        image={previewImg || video.previewImg}
        subtitle={video.subtitle}
        time={video.duration ? video.duration : '00:01'}
        handleDelete={() => handleDelete(item)}
      />
    )
  }

  return (
    <LayoutCard
      id={item.id}
      type={item.type}
      name='This video has been deleted'
      handleDelete={() => handleDelete(item)}
    />
  )
})
